export default {
    apiKey: "AIzaSyC9Gl_xF9AVW4BA6mEOOJ5Vt2ukK_h-tSc",
    discoveryDocs:
        ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
    spreadsheetId: "1SGmuNblJGDbdm9PRBCTwDuslj1Ws09f0ykRM4SkbhUI"
}